<template>
  <div>
    <div v-if="successMessage" class="alert alert-success">{{ successMessage }}</div>
    <div v-if="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>

    <!-- Initial Loading -->
    <div v-if="pageLoading" class="text-center py-5">
      <b-spinner variant="primary" label="Loading..." style="width: 3rem; height: 3rem;"></b-spinner>
      <p class="mt-3 h5">Loading Expense information...</p>
    </div>

    <!-- Main Form -->
    <b-card v-else>
      <b-row>
        <div class="col-12 mt-16">
          <b-form @submit.prevent="updateExpense" v-if="show">
            <!-- Section Heading -->
            <div style="background-color: rgb(97, 116, 152); height: 32px; border-radius: 4px;">
              <h4 style="color: #dfe3ee; margin-left: 5px; font-weight: bold;">
                Update Expense
              </h4>
            </div>

            <div class="row">
              <!-- Title -->
              <div class="col-md-4 col-12">
                <b-form-group label="Title:" label-for="title">
                  <b-form-input id="title" :state="validateField(title)" v-model="title" />
                </b-form-group>
              </div>

              <!-- Date -->
              <div class="col-md-4 col-12">
                <b-form-group label="Expense Date:" label-for="date">
                  <b-form-input id="date" type="date" :state="validateField(expense_date)" v-model="expense_date" required />
                </b-form-group>
              </div>

              <!-- Category -->
              <div class="col-md-4 col-12">
                <b-form-group label="Expense Type:" label-for="category">
                  <b-form-select
                    id="category"
                    :state="validateField(expense_type_id)"
                    v-model="expense_type_id"
                    :options="categories"
                    required
                  />
                </b-form-group>
              </div>

            <!-- Amount -->
              <div class="col-md-4 col-12">
                <b-form-group label="Amount($):" label-for="amount">
                  <b-form-input id="amount" type="number" step="0.01" :state="validateField(amount)" v-model="amount" required />
                </b-form-group>
              </div>
              <!-- Document -->
              <!-- <div class="col-md-4 col-12">
                <b-form-group label="Document:" label-for="document">
                  <div v-if="editedExpense.document">
                    <a :href="'https://wossdb.wossautoid.com/' + editedExpense.document" target="_blank">
                      <i class="fas fa-file-invoice" style="margin-right: 5px;"></i> View Document
                    </a>
                  </div>
                  <input type="file" @change="onDocumentChange" />
                </b-form-group>
              </div> -->
              <!-- Document -->
              <div class="col-md-4 col-12">
                <b-form-group
                  label="Document:"
                  label-for="document"
                  description="Upload PDF/DOCX/JPG/PNG (Max 10MB)"
                >
                  <div
                    class="border rounded p-3 text-center"
                    @click="$refs.docInput.click()"
                    style="cursor: pointer; background-color: #f8f9fa;"
                  >
                    <i class="fas fa-cloud-upload-alt fa-2x text-muted"></i>
                    <p class="mb-0">Drag & Drop or Click to Upload</p>
                    <input
                      type="file"
                      accept=".pdf,.doc,.docx,.jpg,.png"
                      ref="docInput"
                      class="d-none"
                      @change="onDocumentChange"
                    />
                  </div>

                  <!-- Preview or existing file -->
                  <div v-if="document || editedExpense.document" class="d-flex flex-wrap mt-2">
                    <div class="m-2 text-center" style="width: 100px;">
                      <template v-if="document">
                        <div v-if="document.type && document.type.includes('image')">
                          <img
                            :src="getImagePreview(document)"
                            class="img-thumbnail"
                            style="width: 100px; height: 100px; object-fit: cover;"
                          />
                        </div>
                        <div v-else>
                          <i class="fas fa-file-alt fa-3x text-primary"></i>
                        </div>
                      </template>
                      <template v-else>
                        <i class="fas fa-file-invoice fa-3x text-primary"></i>
                      </template>
                      <b-button size="sm" variant="danger" class="mt-1" @click.stop="removeDocument">
                        Remove
                      </b-button>
                    </div>
                  </div>
                </b-form-group>
              </div>

              <!-- Notes -->
              <div class="col-md-12 col-12">
                <b-form-group label="Notes:" label-for="notes">
                  <b-form-textarea id="notes" :class="{  'is-invalid': validateField(description) === false,  'is-valid': validateField(description) === true,}" v-model="description" rows="3" />
                </b-form-group>
              </div>
            </div>

            <!-- Submit -->
            <b-button type="submit" variant="primary" class="mb-8 mr-8" :disabled="isLoading">
              <span v-if="!isLoading">Update</span>
              <b-spinner v-else small></b-spinner>
            </b-button>
          </b-form>
        </div>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormTextarea,
  BSpinner,
} from "bootstrap-vue";
import axios from "../../../axios";

export default {
  data() {
    return {
      show: true,
      pageLoading: true,
      isLoading: false,
      successMessage: "",
      errorMessage: "",

      // Expense fields
      title: "",
      amount: "",
      expense_date: "",
      expense_type_id: null,
      description: "",
      document: "",

      editedExpense: {},
      categories: [], // will load from API
    };
  },
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormTextarea,
    BSpinner,
  },
  created() {
    this.fetchExpense();
    this.fetchCategories();
  },
  methods: {
      validateField(value, type = "text") {
            if (value === null || value === undefined || value === "") return null;

            if (type === "email") {
            const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return regex.test(value);
            }
            if (type === "number") {
            const regex = /^\+?[0-9 ]+$/; // accepts + and spaces
            return regex.test(value.toString().trim());
            }
            return value.toString().trim().length > 0;
      },
    async fetchExpense() {
      const id = this.$route.params.id;
      try {
        const res = await axios.get(`expenses/${id}`);
        this.editedExpense = res.data.data;
        this.title = this.editedExpense.title;
        this.amount = this.editedExpense.amount;
        this.expense_date = this.editedExpense.expense_date;
        this.expense_type_id = this.editedExpense.expense_type_id;
        this.description = this.editedExpense.description;
      } catch (err) {
        this.errorMessage = "Error loading expense details.";
      } finally {
        this.pageLoading = false; // hide loader after API
      }
    },
    async fetchCategories() {
      try {
        const res = await axios.get("expenseTypesForExport");
        this.categories = res.data.data.map((type) => ({
          value: type.id,
          text: type.name,
        }));
      } catch (err) {
        console.error("Error loading categories", err);
      }
    },
    updateExpense() {
      this.isLoading = true;
      const formData = new FormData();
      formData.append("title", this.title || "");
      formData.append("amount", this.amount);
      formData.append("expense_date", this.expense_date);
      formData.append("expense_type_id", this.expense_type_id);
      formData.append("description", this.description || "");
      if (this.document instanceof File) {
        formData.append("document", this.document || "");
      }
      // Add remove_document flag if user clicked remove
      if (!this.document && !this.editedExpense.document) {
        formData.append("remove_document", 1);
      }

      axios
        .post(`expensesUpdate/${this.editedExpense.id}`, formData)
        .then(() => {
          this.$bvToast.toast("Expense updated successfully!", {
            title: "Success",
            variant: "primary",
            solid: true,
            toaster: "b-toaster-top-right",
            autoHideDelay: 5000,
          });
          this.$router.push({ name: "ListExpense" });
        })
        .catch(() => {
          this.errorMessage = "Error updating expense.";
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    onDocumentChange(event) {
    const file = event.target.files[0];
    if (file) {
      this.document = file;
      // Optionally clear old document display if a new file is selected
      this.editedExpense.document = null;
    }
  },
  removeDocument() {
    this.document = null;
    this.editedExpense.document = null;
  },
  getImagePreview(file) {
    return URL.createObjectURL(file);
  },
  },
};
</script>
